import { render, staticRenderFns } from "./DatosContactos.vue?vue&type=template&id=62366c6b&scoped=true&"
import script from "./DatosContactos.vue?vue&type=script&lang=js&"
export * from "./DatosContactos.vue?vue&type=script&lang=js&"
import style0 from "./DatosContactos.vue?vue&type=style&index=0&id=62366c6b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62366c6b",
  null
  
)

export default component.exports